import Icon from '../Icon/Icon';

const CheckmarkIcon = ({className}: {className?: string}) => (
    <Icon width='8' height='7' fill='none' className={className}>
        <path d='M0.5 3.3125L3.16513 5.98572L7.625 0.5' stroke='#393E44' strokeLinecap='round' strokeLinejoin='round' />
    </Icon>
);

export default CheckmarkIcon;
